import { render, staticRenderFns } from "./SearchDocument.vue?vue&type=template&id=21085e35&scoped=true"
import script from "./SearchDocument.vue?vue&type=script&lang=js"
export * from "./SearchDocument.vue?vue&type=script&lang=js"
import style0 from "./SearchDocument.vue?vue&type=style&index=0&id=21085e35&prod&lang=css"
import style1 from "./SearchDocument.vue?vue&type=style&index=1&id=21085e35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21085e35",
  null
  
)

export default component.exports